module.exports = __webpack_public_path__ + "img/023.6b05e0c6.png";